document.addEventListener('DOMContentLoaded', () => {
  const animatedSections = document.querySelectorAll(
    '.hero, .training-stats, .image-content, .training-benefits, .training-faq, .free-training-cta, .final-training-cta, .training-options, .training-programs, .training-goals, .fitness-value, .premium-hero'
  );

  if (!animatedSections.length) return;

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;

      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    });
  }, {
    threshold: 0.15
  });

  animatedSections.forEach((section) => {
    observer.observe(section);
  });
});